import { FunctionComponent } from 'preact';

import { UpNextLayout } from '../UpNextLayout/UpNextLayout';
import { useWindowEvent } from '../../hooks/useWindowEvent';
import { useUpNextCountdownControls } from '../../hooks/useUpNextCountdownControls';

interface EndScreenLayoutProps {
  onCancelClick: () => void;
}

const END_SCREEN_COUNTDOWN_IN_SECONDS = 4;

export const EndScreenLayout: FunctionComponent<EndScreenLayoutProps> = ({
  onCancelClick,
}) => {
  const {
    remainingTime,
    handleCancelClick,
    handleReplayClick,
    handleSkipClick,
  } = useUpNextCountdownControls({
    enabled: true,
    countdownInSeconds: END_SCREEN_COUNTDOWN_IN_SECONDS,
    onCancel: onCancelClick,
  });

  useWindowEvent('popstate', onCancelClick);

  return (
    <UpNextLayout
      handleReplay={handleReplayClick}
      onCancelClick={handleCancelClick}
      onSkipClick={handleSkipClick}
      remainingTime={remainingTime}
      countdownDuration={END_SCREEN_COUNTDOWN_IN_SECONDS}
      disablePreview
    />
  );
};
